export const  CROP_COLOR_MAP: { [key: string]: string } = {
  'Cotton': '#c0c0c0',
  'Wheat': '#ffe119',
  'Corn': '#00FFFF',
  'Rice': '#ffffff',
  'Soybean': '#78A8FC',
  'Sunflower': '#ffbf00',
  'Tomato': '#e6194b',
  'Potato': '#D0AB8B',
  'Mung bean': '#AAFFC3',
  'Watermelon': '#f032e6',
  'Onion': '#ffcc99',
  'Carrot': '#ff7f00',
  'Cucumber': '#008000',
  'Cucumbers': '#008000',
  'Hot pepper': '#800000',
  'Chickpea': '#e6beff',
  'Cabbage': '#a2c523',
  'Intensive Orchards – Walnut': '#D8B99D',
  'Intensive Orchards – Apple': '#bcf60c',
  'Intensive Orchards – Vineyard': '#6750A4',
  'Intensive Orchards – Pomegranate': '#990033'

};
